import laplap from "assets/laplap.png";
import soundFile from "assets/sound.mp3";
import AnimatedContent from "components/home/AnimatedContent";
import BlurText from "components/home/BlurText";
import CountUp from "components/home/CountUp";
import FadeContent from "components/home/FadeContent";
import SpotlightCard from "components/home/SpotlightCard";
import TextType from "components/home/TextType";
import NavbarForHome from "components/PublicLayoutPages/Navbar/NavbarForHome";
import { useEffect, useState } from "react";
import { FaCreditCard, FaGamepad, FaHeadphones } from "react-icons/fa";
import { Link } from "react-router-dom";
function Home() {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const audio = new Audio(soundFile);

    // محاولة تشغيل الصوت تلقائيًا
    audio.play().catch(() => {
      console.log("التشغيل التلقائي للصوت تم حظره من المتصفح");
    });
  }, []);
  return (
    <div dir="rtl" lang="ar" className="font-[Tajawal] antialiased">
      {/* Hero Section */}
      {/* Hero Section */}
      <NavbarForHome />
      <main className="relative min-h-[80vh] flex items-center overflow-hidden bg-mainDark_ border-b border-white/5 px-4 py-20 md:py-0">
        {/* عناصر خلفية جمالية (Background Decorations) */}

        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
          {/* تأثير الشبكة الناعم */}
          <div
            className="absolute inset-0 opacity-[0.03]"
            style={{
              backgroundImage: "radial-gradient(#fff 1px, transparent 1px)",
              size: "40px 40px",
            }}
          ></div>

          {/* كرات ضوئية (Glow Blobs) تعطي فخامة */}
          <div className="absolute -top-24 -left-24 w-96 h-96 bg-mainLight/20 rounded-full blur-[120px] animate-pulse"></div>
          <div className="absolute top-1/2 -right-24 w-64 h-64 bg-mainLight/10 rounded-full blur-[80px]"></div>
        </div>

        <div className="container relative z-10 flex flex-col mt-24 md:flex-row items-center justify-between max-w-6xl mx-auto">
          {/* القسم الأيمن: العناوين */}
          <div className="md:w-3/5 text-right space-y-6">
            <div className="inline-block px-4 py-1 rounded-full border border-mainLight/30 bg-mainLight/5 text-mainLight text-sm mb-4 animate-bounce">
              أدوات المبدعين في مكان واحد
            </div>

            <h1 className="font-extrabold leading-tight">
              <span className="block text-center md:text-right text-mainLight text-6xl md:text-8xl mb-8 drop-shadow-2xl">
                العالمية للابتوب
              </span>

              <BlurText
                text="لأن كل شغف يستحق جهازه المثالي."
                delay={100}
                animateBy="words"
                direction="top"
                className="text-gray-400 text-2xl md:text-4xl font-light tracking-wide"
              />
            </h1>
          </div>

          {/* القسم الأيسر: الوصف والزر */}
          <div className="w-full md:w-2/5 mt-12 md:mt-0 flex flex-col items-center md:items-start text-right">
            <div className="bg-white/5 backdrop-blur-md p-6 rounded-2xl border border-white/10 shadow-2xl w-full max-w-md">
              <div className="h-32 mb-6">
                <TextType
                  text={[
                    "في العالمية للابتوب… نلبي طموحك أياً كان: الدراسة، العمل، أو اللعب.",
                    "وكيل رسمي لأكبر شركات اللابتوب العالمية.",
                  ]}
                  typingSpeed={50}
                  pauseDuration={2000}
                  showCursor={true}
                  cursorCharacter="▋"
                  cursorClassName="text-mainLight"
                  textColors={["#e2e8f0"]}
                  className="text-lg leading-relaxed font-medium"
                />
              </div>

              <div className="flex flex-col gap-4">
                <a
                  href="#products"
                  className="group relative inline-flex items-center justify-center px-8 py-4 overflow-hidden font-bold text-white transition-all duration-300 bg-mainLight rounded-xl hover:bg-mainLight/90 shadow-[0_0_20px_rgba(var(--mainLight-rgb),0.3)] hover:shadow-[0_0_30px_rgba(var(--mainLight-rgb),0.5)]"
                >
                  <span className="relative">تصفح المنتجات الآن</span>
                  {/* سهم يظهر عند التحويم */}
                  <svg
                    className="w-5 h-5 mr-2 transition-transform duration-300 group-hover:-translate-x-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M11 19l-7-7 7-7m8 14l-7-7 7-7"
                    />
                  </svg>
                </a>

                <p className="text-xs text-gray-500 text-center mt-2 italic">
                  ضمان حقيقي 100% على كافة الأجهزة
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Products */}
      <section id="products" className="py-8 md:py-24 px-4">
        <div className="container mx-auto text-center max-w-6xl">
          <h2 className="text-3xl font-bold mb-12 text-mainLight">
            اللابتوبات
          </h2>
          <div className="grid grid-cols-2 gap-8">
            <Link to={"/laptops/new"}>
              <FadeContent
                blur={true}
                duration={500}
                easing="ease-out"
                initialOpacity={0}
              >
                {/* Anything placed inside this container will be fade into view */}
                <SpotlightCard className="relative custom-spotlight-card cursor-pointer group !p-4 md:!p-8 border-2 border-mainLight/20 hover:border-mainLight/50 transition-all duration-500">
                  <div className="absolute -right-10 -top-10 text-mainLight/5 text-8xl md:text-9xl font-bold italic select-none">
                    NEW
                  </div>
                  <img
                    src={laplap}
                    alt="جديد"
                    className="mx-auto mb-4 w-48 group-hover:scale-110 duration-300"
                  />
                  <h3 className="text-xl font-semibold mb-2 text-gray-400 dark:text-white">
                    جديد
                  </h3>
                  <p className="hidden md:block text-gray-400">
                    نقدم أحدث الموديلات التي وصلت حديثاً لتلبية احتياجاتك
                    المتغيرة.
                  </p>
                </SpotlightCard>
              </FadeContent>
            </Link>
            <Link to={"/laptops/europ"}>
              <FadeContent
                blur={true}
                duration={500}
                easing="ease-out"
                initialOpacity={0}
              >
                <SpotlightCard className="relative custom-spotlight-card cursor-pointer group !p-4 md:!p-8 border-2 border-mainLight/20 hover:border-mainLight/50 transition-all duration-500">
                  <div className="absolute -right-10 -top-10 text-mainLight/5  text-8xl md:text-9xl font-bold italic select-none">
                    EURO
                  </div>
                  <img
                    src={laplap}
                    alt="بالة أوربية"
                    className="mx-auto mb-4 w-48 group-hover:scale-110 duration-300"
                  />
                  <h3 className="text-xl font-semibold mb-2 text-gray-400 dark:text-white">
                    بالة أوربية
                  </h3>
                  <p className="hidden md:block text-gray-400">
                    اكتشف لابتوبات مستوردة من أوروبا بجودة عالية وأسعار مميزة.
                  </p>
                </SpotlightCard>
              </FadeContent>
            </Link>
          </div>
          <Link
            to={"/laptops"}
            className="inline-block mt-8 text-gray-400 dark:text-white dark:hover:text-mainLight transition-colors"
          >
            اكتشف المزيد <span className="font-bold">&raquo;</span>
          </Link>
        </div>
      </section>

      {/* Features */}
      <section id="features" className="py-8 md:py-24 px-4 bg-mainLight">
        <div className="container mx-auto text-center max-w-6xl">
          <h2 className="text-3xl font-bold mb-12 text-mainDark">
            المزيد من الاقسام
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {/* Card 1: Laptop Accessories */}

            <AnimatedContent
              distance={150}
              direction="vertical"
              reverse={false}
              duration={1.2}
              ease="bounce.out"
              animateOpacity
              scale={1.1}
              delay={0.3}
            >
              <Link
                to={"accessories"}
                className="bg-white/5 block group shadow-xl p-6 rounded-xl backdrop-blur-lg hover:bg-mainDark duration-500 cursor-pointer h-full transition-all"
              >
                <div className="mb-4">
                  <FaHeadphones className="text-5xl mx-auto text-mainDark group-hover:text-mainLight duration-500" />
                </div>
                <h3 className="text-xl font-semibold mb-2 text-mainDark group-hover:text-mainLight duration-500">
                  اكسسوارات
                </h3>
                <p className="text-mainDark group-hover:text-mainLight duration-500">
                  كل ما تحتاجه لتكمل تجربتك، من الماوس والكيبورد إلى الحقائب
                  وسماعات الرأس.
                </p>
              </Link>
            </AnimatedContent>

            {/* Card 2: Console */}
            <AnimatedContent
              distance={150}
              direction="vertical"
              reverse={false}
              duration={1.2}
              ease="bounce.out"
              animateOpacity
              scale={1.1}
              delay={0.5}
            >
              <Link
                to={"console"}
                className="bg-white/5 block group shadow-xl p-6 rounded-xl backdrop-blur-lg hover:bg-mainDark duration-500 cursor-pointer h-full transition-all"
              >
                <div className="mb-4">
                  <FaGamepad className="text-5xl mx-auto text-mainDark group-hover:text-mainLight duration-500" />
                </div>
                <h3 className="text-xl font-semibold mb-2 text-mainDark group-hover:text-mainLight duration-500">
                  كونسول و اكسسواراته
                </h3>
                <p className="text-mainDark group-hover:text-mainLight duration-500">
                  استمتع بتجربة ألعاب لا مثيل لها مع أحدث أجهزة الكونسول وكافة
                  ملحقاتها.
                </p>
              </Link>
            </AnimatedContent>

            {/* Card 3: Digital Store */}
            <AnimatedContent
              distance={150}
              direction="vertical"
              reverse={false}
              duration={1.2}
              ease="bounce.out"
              animateOpacity
              scale={1.1}
              delay={0.7}
            >
              <Link
                to={"/digital-services"}
                className="bg-white/5 block group shadow-xl p-6 rounded-xl backdrop-blur-lg hover:bg-mainDark duration-500 cursor-pointer h-full transition-all"
              >
                <div className="mb-4">
                  <FaCreditCard className="text-5xl mx-auto text-mainDark group-hover:text-mainLight duration-500" />
                </div>
                <h3 className="text-xl font-semibold mb-2 text-mainDark group-hover:text-mainLight duration-500">
                  متجر سوريا الرقمي
                </h3>
                <p className="text-mainDark group-hover:text-mainLight duration-500">
                  نقدم لك خدمات الدفع والمنتجات الرقمية بسهولة وأمان في مكان
                  واحد.
                </p>
              </Link>
            </AnimatedContent>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-8 md:py-24 px-4">
        <div className="container mx-auto text-center max-w-6xl">
          <h2 className="text-3xl font-bold mb-12 text-mainLight">
            أرقامنا تتحدث
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="p-6 rounded-xl bg-gray-200 dark:bg-white/5 shadow-lg">
              <span className="text-4xl font-extrabold text-mainLight">
                <CountUp from={0} to={125000} separator="," duration={1} />+
              </span>
              <h3 className="text-lg font-semibold mt-2 text-gray-400 dark:text-white">
                زائر شهري
              </h3>
              <p className="text-gray-400 text-sm">شغفك يجد طريقه إلينا.</p>
            </div>
            <div className="p-6 rounded-xl bg-gray-200 dark:bg-white/5 shadow-lg">
              <span className="text-4xl font-extrabold text-mainLight">
                <CountUp from={0} to={7500} separator="," duration={1} />+
              </span>
              <h3 className="text-lg font-semibold mt-2 text-gray-400 dark:text-white">
                عميل سعيد
              </h3>
              <p className="text-gray-400 text-sm">نحن فخورون بثقتكم.</p>
            </div>
            <div className="p-6 rounded-xl bg-gray-200 dark:bg-white/5 shadow-lg">
              <span className="text-4xl font-extrabold text-mainLight">
                <CountUp from={0} to={20000} separator="," duration={1} />+
              </span>
              <h3 className="text-lg font-semibold mt-2 text-gray-400 dark:text-white">
                منتج مباع
              </h3>
              <p className="text-gray-400 text-sm">كل منتج قصة نجاح.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="py-8 md:py-24 px-4 bg-mainLight">
        <div className="container mx-auto text-center max-w-6xl">
          <h2 className="text-3xl font-bold mb-4 text-mainDark">تواصل معنا</h2>
          <p className="text-mainDark mb-8">
            نحن هنا للإجابة على جميع استفساراتك.
          </p>
          <div className="flex flex-col md:flex-row justify-center items-center gap-8">
            <div className="text-center">
              <p className="text-mainDark font-semibold">رقم الهاتف:</p>
              <a
                href="tel:+963989612100"
                dir="ltr"
                className="text-lg text-mainDark  font-bold hover:underline"
              >
                +963 989 612 100
              </a>
            </div>
            {/* <div className="text-center">
              <p className="text-mainDark font-semibold">البريد الإلكتروني:</p>
              <a
                href="mailto:info@alalamia-laptops.com"
                className="text-lg text-mainDark  font-bold hover:underline"
              >
                info@alalamia-laptops.com
              </a>
            </div> */}
          </div>
          <Link
            to={"/contact-us"}
            className="inline-block mt-8 text-gray-400 dark:text-mainDark dark:hover:text-gray-900 transition-colors"
          >
            المزيد <span className="font-bold">&raquo;</span>
          </Link>
        </div>
      </section>

      {/* Footer */}
    </div>
  );
}

export default Home;
